export default "__VITE_ASSET__B$4J55K7__"